// extracted by mini-css-extract-plugin
export default {"container":"styles_container__KXFcJ","block":"styles_block__7c8jM","text":"styles_text__1Cy9-","blockActive":"styles_blockActive__rKtjz"};